
import { Filmomtale } from "@filmweb/sanity-types";
import MoviePoster from "components/movieposter/MoviePoster";
import TicketButton from "components/TicketButton";
import { IMovieArticle } from "lib/types/sanity";
import Show from "lib/types/Show";
import styles from "./OneShowWithPoster.module.css";



//#region [Props]
type OneShowWithPoster = {
    show: Show;
    filmomtale?: Filmomtale;
    showDate?: boolean;
    fwpakkeFilmomtale?: IMovieArticle;
    allowTitleOverride?: boolean;
    showTypeLocation?: "poster" | "ticketbutton";
};
//#endregion

//#region [Component]
export default function OneShowWithPoster({ show, filmomtale, fwpakkeFilmomtale, showDate = false, allowTitleOverride = false, showTypeLocation = "ticketbutton" }: OneShowWithPoster) {

    return <article className={styles.SOneShowWithPoster}>
        <MoviePoster edi={show.movieMainVersionId} fallbackTitle={show.movieTitle} filmomtale={filmomtale} fwpakkeFilmomtale={fwpakkeFilmomtale} allowTitleOverride={allowTitleOverride} label={showTypeLocation === "poster" ? show.showType : undefined} />
        <TicketButton className={styles.STicketButton} show={show} showDate={showDate} showPassed appendShowType={showTypeLocation === "ticketbutton"} />
    </article>
}
//#endregion